import React, { useEffect, useState, useMemo } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { Card } from '~/components';
import { useAuth, useRouter } from '~/hooks';
import { SectionNav } from '~/components/Section';
import Layout from '../templates/DefaultLayout';
import { AiFillHome, AiFillDollarCircle  } from 'react-icons/ai';
import { MdPrint, MdContentCopy } from 'react-icons/md';
import { TiTickOutline, CgNotes, IoMdMap, BsBellFill, AiFillProfile, MdDirectionsWalk, GiCheckMark, RiEditFill } from 'react-icons/all';
import { PropertyInfos, TaxesAndSpecialAssesmentss, RestrictiveCovenantss, RecordedPlats, Lienss, Easementss, DeedOfTusts, AdditionalInformations, Reviews, Submits } from './sections';
import { titleOpinionApi } from '~/api';
import { titleOpinionContext, withTitleOpinion , useSubmitReviewForm} from './hooks';
import { DateTime } from 'luxon';
import NextPrevious from '~/components/Section/NextPrevious';
import { generateDocument } from './generateSTFDoc';
import sectionTypes from './sections/sectionTypes';
import SubmitRevision from './submitRevision';
import { document } from '~/api';
import { addAttachment, duplicateTitleOpinion as duplicateTitleOpinionApi } from '~/api/titleOpinion';
import { generatePXTFile } from './generatePXTFile';
import dataFieldsToDuplicate from '~/util/dataFieldsToDuplicate';
import titleOpinionStatus from '~/util/titleOpinionStatus';
import FileNumberPopup from './fileNumberPopup';

const INITIAL_PATH_NAMES = ["/StraightFinal/0", "/StraightFinal/0/propertyInfos"];

const StraightToFinal = () => {
    let { params, match: { url }, query } = useRouter('/StraightFinal/:id');
    const { pathname, replace, history } = useRouter();
    const { isTryon, user } = useAuth();
    
    const isRevision = query.get('action') === 'revision';

    const [titleOpinion, setTitleOpinion] = useState(null);
    const [submitRevision, setSubmitRevision] = useState(isRevision);
    const [successMessage, setSuccessMessage] = useState(false);    

    const existingOpinion = useMemo(() => titleOpinion && titleOpinion.id, [titleOpinion]);
    const orderNumber = titleOpinion ? titleOpinion.orderNumber : null;
    const allowRevision = (titleOpinion && titleOpinion.statusId == 2) ? true : false;
    const readOnly = (isTryon || (titleOpinion && titleOpinion.statusId == 2)) ? true : false;
    //const errorMessage = titleOpinion ? titleOpinion.errorMessage : null;
    const submittedOpinion = (titleOpinion && titleOpinionStatus.SFTO.SUBMITTED == titleOpinion.statusId) ? true : false;
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        const getOpinion = async () => {
            if (params.id && params.id != 0) {
                const opinion = await titleOpinionApi.getTitleOpinion(params.id);
                setTitleOpinion(opinion);
            }
        };
        getOpinion();
    }, [params.id]);

    const printSTFDOC = async() => {
        generateDoc(true);
    };


    const generateDoc = async(isPrintOnly = false) => {
        let canGeneratePXTFile = user?.preferences?.sendPPTXFile;
        canGeneratePXTFile = canGeneratePXTFile == undefined || canGeneratePXTFile == '' ||  canGeneratePXTFile == 'true' ? true : false;

        await titleOpinionApi.getStraightFinalOpinionDoc(params.id)
            .then(async(res) => {
                return Promise.all([
                    generateDocument(res, params.id, isPrintOnly),
                    canGeneratePXTFile && generatePXTFile(res, params.id, isPrintOnly)
                ]);
            })
            .catch((err) => {
                alert(' Issue generating STF documents. Please share error with support. Error: ' + err.message + ' stack:' + err.stack);
            })
            .then(async() => {
                //generate pto email with documents/attachments
                return !isPrintOnly && await titleOpinionApi.sendEmailOnSubmitSTF(params.id);
            }).catch((err) => alert(' Issue sending email.  Please share error with support. Error: ' + err));
    };
        
    const submitSTFRevision = async (values) => {
        const details = {
            revisions: values.revisions,
            files: values.files ? values.files : []
        };
        setSubmitRevision(false);
        details.files.map(file => {
            const desc = "STF Revision Document - Title Opinion Id - " + params.id;
            const attachment = { ...file.uploadInfo, typeId: document.DocumentType.STF_REVISION, description: desc };
            document.upload(file);
            addAttachment(params.id ,attachment).then((res)=>{
                return res;
            }).catch((err) => {
                console.error(err);
            });
        });

        await titleOpinionApi.submitRevision(params.id, details);
        setSuccessMessage(true);
        setTimeout(() => {
            setSuccessMessage(false);
        }, 2500);                
    };

    const submitSTFRequest = async() => {
        useSubmitReviewForm(params.id, sectionTypes.REVIEW_PTO).then(value => 
        {
            if((Object.keys(value.errorSections).length !== 0) 
            && (Object.values(value.errorSections).filter(v=> v === true).length === 0) 
            && value.attorney 
            && value.attorney != null) {
                generateDoc();
                titleOpinionApi.submitSTF(params.id);
                replace(pathname.replace(`/review`, `/submit`));
            } else {
                alert(' Please complete the STF request to submit.');
            }
        });
        
    };

    const duplicateSTF = async() => {
        const payload = {
            statusId: titleOpinionStatus.SFTO.DRAFTED,
            titleOpinionId_original: params.id,
            dataToDuplicate: dataFieldsToDuplicate.STF_DATA_FIELDS_DUPLICATE.dataToDuplicate
        };

        const result = await duplicateTitleOpinionApi(payload);
        if(+result?.id > 0) {
            history.push("/StraightFinal/" + result.id);
        } else {
            alert("Sorry. Unable to duplicate Straight To Final Opinion");
        }
    };

    const overlayTitleOpinion =async()=> {
        if(+params.id <= 0 || params.id == undefined || params?.id == null) return;
        setOpen(true);
    };

    return (
        <Layout>
            <titleOpinionContext.Provider value={{ titleOpinion, existingOpinion, titleOpinionId: params.id, readOnly: readOnly, orderNumber: orderNumber}}>
                <div className="container h-full flex flex-col">
                    <div className="flex flex-row justify-between">
                        <h1 className='text-blue-60 text-3xl font-semibold mt-12'>Straight To Final Title Opinion</h1>
                        {successMessage ?                        
                            <Card className="h-9 mt-2 px-4 py-2 flex flex-row rounded-md bg-lightGreen-300 text-white focus:outline-none drop-shadow-none text-sm"> 
                                <div className="flex flex-row" ><GiCheckMark size="1.25rem"/> &nbsp; Revision Request submitted successfully. Thank You.</div> 
                            </Card>
                            :
                            <> </>
                        }
                        {allowRevision ?
                            <div className="flex flex-row justify-center">
                                <button 
                                    className="mt-12 py-2 px-4 flex ml-4 rounded-md bg-blue-50 text-white focus:outline-none"
                                    onClick={() => setSubmitRevision(true)}>
                                    <RiEditFill size="1em" className="mr-1 mt-1" />
                                    Submit Revision
                                </button>
                                <button 
                                    className="mt-12 py-2 px-4 flex  ml-4 rounded-md bg-blue-50 text-white focus:outline-none"
                                    onClick={printSTFDOC}>
                                    <MdPrint size="1em" className="mr-1 mt-1" />
                                    Print
                                </button>
                            </div>
                            :
                            <div className="flex flex-row justify-center">
                                {
                                    !submittedOpinion && !INITIAL_PATH_NAMES.includes(pathname) &&
                                    <>
                                        <span
                                            className='transititext-primary text-primary transition duration-150 ease-in-out hover:text-primary-600 focus:text-primary-600 active:text-primary-700 dark:text-primary-400 dark:hover:text-primary-500 dark:focus:text-primary-500 dark:active:text-primary-600' 
                                            data-te-toggle="tooltip"
                                            title="This action will over-write all of the information contained in this file with the content of the file number you enter."
                                        >                                       
                                            <button 
                                                className="mt-12 mr-2 py-2 px-4 flex justify-between rounded-md bg-blue-50 text-white focus:outline-none"
                                                onClick={() => overlayTitleOpinion()}>
                                                <MdContentCopy size="1em" className="mr-1 mt-1" />
                                                Overlay Order
                                            </button>
                                        </span> 
                                        <FileNumberPopup isOpen={isOpen} setOpen={setOpen} titleOpinionId={params.id}/>
                                    </>
                                }
                                {
                                    !INITIAL_PATH_NAMES.includes(pathname) && 
                                    <>
                                        <button 
                                            className="mt-12 mr-2 py-2 px-4 flex justify-between rounded-md bg-blue-50 text-white focus:outline-none"
                                            onClick={() => duplicateSTF()}>
                                            <MdContentCopy size="1em" className="mr-1 mt-1" />
                                            Duplicate Order
                                        </button>
                                        <button 
                                            className="mt-12 py-2 px-4 flex justify-between rounded-md bg-blue-50 text-white focus:outline-none"
                                            onClick={printSTFDOC}>
                                            <MdPrint size="1em" className="mr-1 mt-1" />
                                            Print
                                        </button>
                                    </>
                                }
                            </div>
                        }
                        
                    </div>
                    <div className='flex items-center text-xs'>
                        {existingOpinion && (
                            <React.Fragment>
                                <p>
                                    <span className='font-semibold'>Last Updated On </span>
                                    {DateTime.fromISO(titleOpinion.modified).toLocaleString(DateTime.DATETIME_FULL)}
                                </p>
                                <p className="ml-4 my-2"><span className='font-semibold'>Updated By </span>{`${titleOpinion.modifiedBy.firstName} ${titleOpinion.modifiedBy.lastName}`}</p>
                            </React.Fragment>
                        )}
                    </div>
                    {existingOpinion && orderNumber ?
                        <Card className="w-full h-8 bg-lightGreen-300 text-sm text-white p-2 rounded-md mb-0 drop-shadow-none"> 
                            <p> {`Order - ${titleOpinion.orderNumber} Submitted on ${DateTime.fromISO(titleOpinion.submitted).toLocaleString()} by ${titleOpinion.submittedBy.firstName} ${titleOpinion.modifiedBy.lastName}`}</p> 
                        </Card>
                        :
                        existingOpinion && allowRevision ? 
                            <Card className="w-full h-8 bg-lightGreen-300 text-sm text-white p-2 rounded-md mb-0 drop-shadow-none"> 
                                <p>{`Submitted on ${DateTime.fromISO(titleOpinion.submitted).toLocaleString()} by ${titleOpinion.submittedBy.firstName} ${titleOpinion.submittedBy.lastName}`}</p> 
                            </Card>
                            : 
                            <> </>
                        
                    }
                    
                    {submitRevision ?                        
                        <SubmitRevision  
                            isModalOpen={submitRevision}
                            onCancel={() => setSubmitRevision(false)}
                            onSubmit={(values) => submitSTFRevision(values)}
                            headerTxt={'Submit Revision'}
                        />
                        :
                        <> </>
                    }
                    
                    <SectionNav className="mt-10">
                        <SectionNav.Link to={`${url}/propertyInfos`} icon={AiFillHome} text='Property Information' />
                        <SectionNav.Link to={`${url}/taxes`} icon={AiFillDollarCircle} text='Taxes &amp; Special Assessments' />
                        <SectionNav.Link to={`${url}/covenant`} icon={CgNotes} text='Restrictive Covenants &amp; Conditions' />
                        <SectionNav.Link to={`${url}/plat`} icon={IoMdMap} text='Recorded Plat' />
                        <SectionNav.Link to={`${url}/lien`} icon={BsBellFill} text='Canceled/Previous Liens, Mortgages, &amp; Deeds of Trust'/>
                        <SectionNav.Link to={`${url}/easement`} icon={MdDirectionsWalk} text='Easements &amp; Rights of Way'/>
                        <SectionNav.Link to={`${url}/deedoftust`} icon={AiFillProfile} text='Deed Information'/>
                        <SectionNav.Link to={`${url}/additionalInfo`} icon={AiFillHome} text='Additional Information'/>
                        <SectionNav.Link to={`${url}/review`} icon={TiTickOutline} text='Final Review'/>
                    </SectionNav>
                    <Card className="flex-1 my-8 rounded-md py-4 px-2">
                        <div className="flex flex-col h-full items-stretch">
                            <Switch>
                                <Redirect path={url} exact to={`${url.trimEnd('/')}/propertyInfos`} />
                                <Route path={`${url}/propertyInfos`} component={() => withTitleOpinion(PropertyInfos)} />
                                <Route path={`${url}/taxes`} component={() => withTitleOpinion(TaxesAndSpecialAssesmentss)} />
                                <Route path={`${url}/covenant`} component={() => withTitleOpinion(RestrictiveCovenantss)} />
                                <Route path={`${url}/plat`} component={() => withTitleOpinion(RecordedPlats)}/>
                                <Route path={`${url}/lien`} component={() => withTitleOpinion(Lienss)}/>
                                <Route path={`${url}/easement`} component={() => withTitleOpinion(Easementss)}/>
                                <Route path={`${url}/deedoftust`} component={() => withTitleOpinion(DeedOfTusts)}/>
                                <Route path={`${url}/additionalInfo`} component={() => withTitleOpinion(AdditionalInformations)}/>
                                <Route path={`${url}/review`} component={() => withTitleOpinion(Reviews)}/>
                                <Route path={`${url}/submit`} component={() => withTitleOpinion(Submits)}/>
                            </Switch>
                            <NextPrevious sections={['propertyInfos', 'taxes', 'covenant', 'plat', 'lien', 'easement', 'deedoftust', 'additionalInfo', 'review']} 
                                submit={submitSTFRequest}
                                canSubmit={!readOnly}
                            />               
                        </div>
                    </Card>                    
                </div>
            </titleOpinionContext.Provider>
        </Layout>
    );
};

export default StraightToFinal;
